<ion-content class="session-expired-content ion-padding">
  <div class="session-expired-inner">
    <ion-icon class="session-expired-icon" src="/assets/images/notification-error.svg"></ion-icon>
    <h2 class="session-expired-title">Sessão expirada</h2>
    <p class="session-expired-text">{{ message }}</p>
    <button (click)="dismissAndContinue()" class="btn-cancel" fill="clear" color="#fff">
      <ion-label>Ok</ion-label>
    </button>
  </div>
</ion-content>
